import React from 'react'
import CertImg from './certification.png';
import GroupImg from './group.png';
import ContentImg from './content.png';
import hamburgerImg from './hamburger.png';

type Props = {}

const data = [
    {
        des: "Protected content",
        imgSrc: ContentImg
    },
    {
        des: "Study Group",
        imgSrc: GroupImg
    },
    {
        des: "Certification",
        imgSrc: CertImg
    },
    {
        des: "Other",
        imgSrc: hamburgerImg
    },
];

const CertificationPage: React.FC<Props> = () => {
    return (
        <div>
            <h1>
                Additional terms
            </h1>
            <p>
                DevNet Terms of Service applies to the services listed below. Next to each service, we also list
                additional terms and policies that apply to that particular service. The Terms of Service, additional
                terms, and policies define our relationship and mutual expectations as you use these services.
            </p>
            <p>
                This list only includes services governed by DevNet general Terms of Service. A limited number of
                popular services may have their own terms because of their unique features.
            </p>
            <p>
                We often launch new services and sometimes update our terms and policies. We do our best to keep this
                page up to date, and aim to refresh it regularly.
            </p>
            <div className="grid grid-flow-row grid-cols-2 color-primary-blue cursor-pointer">
                {data.map((item)=>{
                    return <div className="flex-center p-4" key={item.des}>
                        <img src={item.imgSrc} alt={item.des} className={"w-12 mr-6 flex"}/> {item.des}
                    </div>
                })}
            </div>

            {/*<Link to="/" > Go to Homepage </Link>*/}
        </div>
    )
};


export default CertificationPage;
